import { render, staticRenderFns } from "./PatchInventory.vue?vue&type=template&id=6b1f3571&scoped=true"
import script from "./PatchInventory.vue?vue&type=script&lang=js"
export * from "./PatchInventory.vue?vue&type=script&lang=js"
import style0 from "./PatchInventory.vue?vue&type=style&index=0&id=6b1f3571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f3571",
  null
  
)

export default component.exports